import { ChevronRight } from 'lucide-react'
import { Link, useLocation, useMatches } from 'react-router'
import { crumbsFromMatches, daftarDariKeadaan } from './crumbs'

/**
 * Ancestors only, in `label` muted; the current page is the route's own h1 with the
 * pigment-tick. Renders nothing on top-level routes. The list the page was opened from goes
 * back to the address it had (`daftarDariKeadaan`).
 */
export function Breadcrumbs() {
  const crumbs = crumbsFromMatches(useMatches(), daftarDariKeadaan(useLocation().state))
  if (crumbs.length < 2) return null
  const ancestors = crumbs.slice(0, -1)
  return (
    <nav aria-label="Jejak halaman" className="pt-6 text-label text-muted">
      <ol className="flex flex-wrap items-center gap-1">
        {ancestors.map((crumb) => (
          <li key={crumb.to} className="flex items-center gap-1">
            <Link
              to={crumb.to}
              className="inline-flex items-center underline-offset-4 hover:text-secondary hover:underline focus-settle pointer-coarse:min-h-11"
            >
              {crumb.label}
            </Link>
            <ChevronRight size={14} aria-hidden="true" />
          </li>
        ))}
      </ol>
    </nav>
  )
}
